import { FormControl, FormHelperText, TextField } from '@mui/material';

interface TxtCategoriaAcessoInformacaoProps {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  helperText?: string;
  required?: boolean;
  name?: string;
  disabled?: boolean;
}

export const TxtCategoriaAcessoInformacao = ({ value, onChange, helperText, required = false, name = 'categoria', disabled = false }: TxtCategoriaAcessoInformacaoProps) => {
  return (
    <FormControl fullWidth size="small">
      <TextField select required={required} size="small" name={name} value={value} onChange={onChange} SelectProps={{ native: true }} disabled={disabled}>
        <option value="">Selecione a Categoria</option>
        <option value="LICITACAO-E-CONTRATOS-ADMINISTRATIVOS">Licitação e contratos administrativos</option>
        <option value="RESULTADOS-DAS-ACOES-REALIZADAS-PELOS-ORGAOS-DE-CONTROLE">Resultados das ações realizadas pelos órgãos de controle</option>
        <option value="ATIVIDADES-EXERCIDAS">Atividades exercidas</option>
        <option value="PROJETOS-E-ACOES-DOS-ORGAOS-E-ENTIDADES-PUBLICAS">Projetos e ações dos órgãos e entidades públicas</option>
        <option value="UTILIZACAO-RECURSOS-PUBLICOS">Utilização de recursos públicos</option>
      </TextField>

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};
